import styled from 'styled-components/macro'
import { ReactComponent as ErrorSVG } from 'src/components/Icons/Basic/icons_badge_error.svg'
import { ReactComponent as SuccessSVG } from 'src/components/Icons/Basic/icons_badge_success.svg'

export const ErrorIcon = styled(ErrorSVG)`
  width: 16px;
  height: 16px;
`

export const SuccessIcon = styled(SuccessSVG)`
  width: 16px;
  height: 16px;
`
